import { useQuery } from '@tanstack/react-query';
import { fetchEvent } from '@/utils/graphqlClient';

export interface EventDetail {
  id: string;
  slug: string;
  event_type?: string;
  description?: string;
  before_extracts?: any;
  after_extract?: any;
  verified?: boolean;
  partially_correct?: boolean;
  invalid?: boolean;
  asset_id?: string;
  created_at?: string;
  updated_at?: string;
  v_before?: string;
  v_after?: string;
  page_id?: string;
}

/**
 * Hook for fetching a single event by ID
 */
export function useEvent(eventId: string, placeholderData?: EventDetail) {
  return useQuery({
    queryKey: ['event', eventId],
    queryFn: async (): Promise<EventDetail> => {
      const response = await fetchEvent(eventId);
      return response.event;
    },
    placeholderData,
    enabled: !!eventId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 30, // 30 minutes
  });
}
